import pocduction from '@/router/jm/pocduction/pocduction.js'
import jmHome from '@/components/jm/home.vue'
import platform from '@/router/jm/platform/platform.js'
import adv from '@/router/jm/adv/adv.js'
import facility from '@/router/jm/facility/facility.js'
import admin from '@/router/jm/admin/admin.js'
import finance from '@/router/jm/finance/finance.js'
import xinmeiti from '@/router/jm/xinmeiti/xinmeiti.js'
import android from '@/router/jm/android/android.js'
export default [{ //设备生产者
	path: 'jm',
	name: 'jm',
	component:jmHome,
	children: [
		...pocduction,
		...platform,
		...adv,
		...facility,
		...admin,
		...finance,
		...xinmeiti,
		...android
	]
}]


// WEBPACK FOOTER //
// ./src/router/jm/jm.js